import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'
import { buildUrl } from '../utils/helpers'

export const GET_USER_REQUEST = 'GET_USER_REQUEST'
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS'
export const GET_USER_FAILURE = 'GET_USER_FAILURE'

export const GET_USERS_REQUEST = 'GET_USERS_REQUEST'
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS'
export const GET_USERS_FAILURE = 'GET_USERS_FAILURE'

export const POST_USERS_REQUEST = 'POST_USERS_REQUEST'
export const POST_USERS_SUCCESS = 'POST_USERS_SUCCESS'
export const POST_USERS_FAILURE = 'POST_USERS_FAILURE'

export const GET_USER_BY_ID_REQUEST = 'GET_USER_BY_ID_REQUEST'
export const GET_USER_BY_ID_SUCCESS = 'GET_USER_BY_ID_SUCCESS'
export const GET_USER_BY_ID_FAILURE = 'GET_USER_BY_ID_FAILURE'

export const PATCH_USERS_REQUEST = 'PATCH_USERS_REQUEST'
export const PATCH_USERS_SUCCESS = 'PATCH_USERS_SUCCESS'
export const PATCH_USERS_FAILURE = 'PATCH_USERS_FAILURE'

export const POST_RESEND_EMAIL_REQUEST = 'POST_RESEND_EMAIL_REQUEST'
export const POST_RESEND_EMAIL_SUCCESS = 'POST_RESEND_EMAIL_SUCCESS'
export const POST_RESEND_EMAIL_FAILURE = 'POST_RESEND_EMAIL_FAILURE'

export const CANCEL_CREATE_USERS = 'CANCEL_CREATE_USERS'
export const SET_USERS_FILTER = 'SET_USERS_FILTER'
export const CLEAR_USERS_FILTER = 'CLEAR_USERS_FILTER'

const buildDataUrl = (filter, sortData) => {
  const { name, page, is_active, business_id, groups } = filter
  let limit = 100
  let queryParams = {}

  if (page && limit) {
    const offset = (page - 1) * limit
    queryParams = { ...queryParams, ...{ page, limit, offset } }
  }

  if (name) {
    queryParams = { ...queryParams, ...{ name } }
  }
  if (is_active) {
    if (is_active !== 'All') {
      queryParams = { ...queryParams, ...{ is_active } }
    }
  }
  if (business_id) {
    queryParams = { ...queryParams, ...{ business_id } }
  }
  if (groups) {
    queryParams = { ...queryParams, ...{ groups } }
  }

  if (sortData) {
    const { field, order } = sortData
    if (field && order) {
      const ordering = order === 'asc' ? field : `-${field}`
      queryParams = { ...queryParams, ...{ ordering } }
    }
  }
  return buildUrl(`/api/users/`, {
    ...queryParams,
  })
}

export const getUser = () => ({
  [CALL_API]: {
    endpoint: '/api/account/profile/',
    types: [GET_USER_REQUEST, GET_USER_SUCCESS, GET_USER_FAILURE],
    method: 'GET',
    tokenType: API_JWT_TOKEN_NAME,
  },
})

export const getUserById = (id) => ({
  [CALL_API]: {
    endpoint: `/api/users/${id}`,
    types: [GET_USER_BY_ID_REQUEST, GET_USER_BY_ID_SUCCESS, GET_USER_BY_ID_FAILURE],
    method: 'GET',
    tokenType: API_JWT_TOKEN_NAME,
  },
})

export const getUsers = (filter, sortDate) => ({
  [CALL_API]: {
    endpoint: buildDataUrl(filter, sortDate),
    types: [GET_USERS_REQUEST, GET_USERS_SUCCESS, GET_USERS_FAILURE],
    method: 'GET',
    tokenType: API_JWT_TOKEN_NAME,
  },
})

export const createUser = (body) => ({
  [CALL_API]: {
    endpoint: '/api/users/',
    types: [POST_USERS_REQUEST, POST_USERS_SUCCESS, POST_USERS_FAILURE],
    method: 'POST',
    tokenType: API_JWT_TOKEN_NAME,
    body,
  },
})

export const updateUser = (id, body) => ({
  [CALL_API]: {
    endpoint: `/api/users/${id}`,
    types: [PATCH_USERS_REQUEST, PATCH_USERS_SUCCESS, PATCH_USERS_FAILURE],
    method: 'PATCH',
    tokenType: API_JWT_TOKEN_NAME,
    body,
  },
})
export const resendEmail = (email) => ({
  [CALL_API]: {
    endpoint: `/api/send-welcome-email/`,
    types: [POST_RESEND_EMAIL_REQUEST, POST_RESEND_EMAIL_SUCCESS, POST_RESEND_EMAIL_FAILURE],
    method: 'POST',
    tokenType: API_JWT_TOKEN_NAME,
    body: { email },
  },
})

const setFilter = (filter) => ({
  type: SET_USERS_FILTER,
  filter,
})

const clearFilter = (filter) => ({
  type: CLEAR_USERS_FILTER,
  filter,
})

export const setUsersFilter = (content) => (dispatch) => dispatch(setFilter(content))

export const clearUsersFilter = (content) => (dispatch) => dispatch(clearFilter(content))
